// Copyright (c) 2020 WiseTime. All rights reserved.

import { Action } from "redux"
import { Observable } from "rxjs"
import { filter, map } from "rxjs/operators"
import * as Actions from "../actions"
import { ToastOptions } from "react-toastify/dist/types"
import { toast } from "react-toastify"
import { combineEpics } from "redux-observable"
import { RootState } from "../../../app/store"
import ErrorMessage from "../ErrorMessage"

type MessageType = "SUCCESS" | "INFO" | "ERROR"

export type SnackBar = {
  message: string,
  messageType: MessageType,
  options?: ToastOptions,
  displayContactInfo?: boolean,
}

export const handleOptions = (snackBar: SnackBar) => {
  if (snackBar.options !== undefined) {
    return ({
      ...snackBar.options,
      toastId: snackBar.options.toastId || snackBar.message,
    })
  }
  return ({
    toastId: snackBar.message,
  })
}

const showToast = ({ displayContactInfo = true, ...snackBar }: SnackBar): void => {
  const options = handleOptions(snackBar)
  switch (snackBar.messageType) {
    case "SUCCESS":
      toast.success(snackBar.message, options)
      break
    case "INFO":
      toast.info(snackBar.message, options)
      break
    case "ERROR":
      toast.error(displayContactInfo ? ErrorMessage(snackBar) : snackBar.message, options)
      break
    default:
      toast(snackBar.message, options)
  }
}

export const showSnackBar = (action$: Observable<Action>): Observable<Action> =>
  action$.pipe(
    filter(Actions.showSnackBar.match),
    map(action => showToast(action.payload)),
    map(Actions.snackBarDone)
  )

export const hideSnackBar = (action$: Observable<Action>): Observable<Action> =>
  action$.pipe(
    filter(Actions.hideSnackBar.match),
    map(action => toast.dismiss(action.payload)),
    map(Actions.snackBarDone)
  )

export default combineEpics<Action, Action, RootState, unknown>(
  showSnackBar,
  hideSnackBar,
)
